import React from 'react';

const AppFeaturesNura = () => {
  const features = [
    {
      image: 'https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/lzmu2vj6_fair%20and%20transparent%20charges%20%282%29.png',
      title: 'Fair and Transparent Charges',
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/tjkeqn6c_Real%20Time%20GPS.png',
      title: 'Real-time GPS tracking',
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/fbqsb7ob_No%20cancellation.png',
      title: 'Zero Cancellation',
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/7bvai0ur_Verified.png',
      title: 'Safety Snapshot',
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/2gfx7azz_Auto%20with%20a%20Charger.png',
      title: 'Auto with a Charger',
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/fbqsb7ob_No%20cancellation.png',
      title: 'SOS Button',
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/2gfx7azz_Auto%20with%20a%20Charger.png',
      title: 'Hygiene Compliant',
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/7bvai0ur_Verified.png',
      title: 'Verified drivers',
    },
  ];

  return (
    <section id="features" className="py-16 sm:py-24 bg-white relative">
      {/* Background Image - Chennai Skyline - Hidden on mobile, visible on desktop */}
      <div className="absolute inset-0 opacity-100 hidden md:block" style={{ top: '350px' }}>
        <img 
          src="https://customer-assets.emergentagent.com/job_nura-website-copy/artifacts/x0qe91yg_Chennai%20Skyline-Con7BI9t.png" 
          alt="Chennai Skyline" 
          className="w-full h-full object-contain object-center"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 flex items-center justify-center gap-2 sm:gap-4 flex-wrap">
            Why{' '}
            <img 
              src="https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/h4ys6fx7_logo.png" 
              alt="Nura" 
              className="h-16 sm:h-20"
              style={{ marginTop: '10px' }}
            />
            <span>?</span>
          </h2>
        </div>

        {/* GIF and All-electric rides text */}
        <div className="text-center mb-12 sm:mb-16">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_nura-website-copy/artifacts/5feg1t09_Nura%20Leaflet-3%20%282%29.gif" 
              alt="Electric Auto" 
              className="w-24 h-24 sm:w-32 sm:h-32 object-contain"
            />
            <h3 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900">
              All-electric rides
            </h3>
          </div>
          
          <p className="text-lg sm:text-xl text-gray-600 px-4">
            Dependable, Secure & Premium Ride Experience
          </p>
        </div>

        {/* Mobile: 2 columns (2x4 grid), Desktop: 4 columns */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 md:gap-12 max-w-5xl mx-auto justify-items-center">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center transform hover:scale-110 transition-all duration-300"
            >
              <div className="mb-4">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-24 h-24 sm:w-32 sm:h-32 object-contain"
                />
              </div>
              <p className="text-sm sm:text-base font-semibold text-gray-900 px-2">{feature.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AppFeaturesNura;